import { put, get } from './requests'

export const getSettings = key =>
  get(['users', 'getSettings'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const updateSettings = key => payload =>
  put(
    ['users', 'updateSettings'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )



// WEBPACK FOOTER //
// ./src/services/settings.js